export class PriceRuleOrganisationModel {
    public priceRuleOrganisationId: string;
    public priceRuleOrganisationTypeCode: string;
    public organisationId: string;
    public organisationTypeCode: string;
    public organisationRoleCode: string;
    public organisationGroupCode: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}